import { call, put, takeLatest } from 'redux-saga/effects';
import { taskService } from './tasks.service';
import {
    CREATE_TASK,
    GET_TASKS,
    GET_TASKS_SUCCESS,
    GET_TASK_BY_ID,
    GET_TASK_BY_ID_SUCCESS,
    UPDATE_TASK,
    DELETE_TASK,
    BULK_UPDATE_TASK_STATUS,
    BULK_ASSIGN_TASK,
    BULK_DELETE_TASKS,
    CREATE_TASK_COMMENT,
    CREATE_TASK_COMMENT_SUCCESS,
    GET_TASK_COMMENTS,
    GET_TASK_COMMENTS_SUCCESS,
    DELETE_TASK_COMMENT,
} from './tasks.type';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

/** Create Task */
function* createTask(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(taskService.createTaskService, action.payload.body);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Get Tasks */
function* getTasks(action) {
    if (action.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(taskService.getTasksService, action.payload.params);
        yield put({
            type: GET_TASKS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_TASKS_SUCCESS,
            payload: { tasks: [], count: 0 },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Get Task By Id */
function* getTaskById(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(taskService.getTaskByIdService, action.payload.id);
        yield put({
            type: GET_TASK_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Update Task */
function* updateTask(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(taskService.updateTaskService, action.payload.id, action.payload.body);
        if (action.payload.requestParams) {
            const res = yield call(taskService.getTasksService, action.payload.requestParams);
            yield put({
                type: GET_TASKS_SUCCESS,
                payload: res.data,
            });
        }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Delete Task */
function* deleteTask(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(taskService.deleteTaskService, action.payload.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Bulk Update Status */
function* bulkUpdateTaskStatus(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(taskService.bulkUpdateStatusService, action.payload.body);
        // if(action.payload.requestParams) {
        //     const res = yield call(taskService.getTasksService, action.payload.requestParams);
        //     yield put({
        //         type: GET_TASKS_SUCCESS,
        //         payload: res.data,
        //     });
        // }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Bulk Assign */
function* bulkAssignTask(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(taskService.bulkAssignService, action.payload.body);
        // if(action.payload.requestParams) {
        //     const res = yield call(taskService.getTasksService, action.payload.requestParams);
        //     yield put({
        //         type: GET_TASKS_SUCCESS,
        //         payload: res.data,
        //     });
        // }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Bulk Delete */
function* bulkDeleteTasks(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(taskService.bulkDeleteService, action.payload.body);
        // if(action.payload.requestParams) {
        //     const res = yield call(taskService.getTasksService, action.payload.requestParams);
        //     yield put({
        //         type: GET_TASKS_SUCCESS,
        //         payload: res.data,
        //     });
        // }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Create Comment */
function* createTaskComment(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(taskService.createCommentService, action.payload.taskId, action.payload.body);
        yield put({
            type: CREATE_TASK_COMMENT_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Get Comments */
function* getTaskComments(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(taskService.getCommentsService, action.payload.taskId, action.payload.params);
        yield put({
            type: GET_TASK_COMMENTS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_TASK_COMMENTS_SUCCESS,
            payload: { comments: [], count: 0 },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Delete Comment */
function* deleteTaskComment(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(taskService.deleteCommentService, action.payload.taskId, action.payload.commentId);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

export const watchTasks = function* watchTasksSaga() {
    yield takeLatest(CREATE_TASK, createTask);
    yield takeLatest(GET_TASKS, getTasks);
    yield takeLatest(GET_TASK_BY_ID, getTaskById);
    yield takeLatest(UPDATE_TASK, updateTask);
    yield takeLatest(DELETE_TASK, deleteTask);
    yield takeLatest(BULK_UPDATE_TASK_STATUS, bulkUpdateTaskStatus);
    yield takeLatest(BULK_ASSIGN_TASK, bulkAssignTask);
    yield takeLatest(BULK_DELETE_TASKS, bulkDeleteTasks);
    yield takeLatest(CREATE_TASK_COMMENT, createTaskComment);
    yield takeLatest(GET_TASK_COMMENTS, getTaskComments);
    yield takeLatest(DELETE_TASK_COMMENT, deleteTaskComment);
};
